import { lazy } from "react";

import {
  backtrackRouteChildren,
  frondeskRouteChildren,
  houseKeepingRouteChildren,
  mainBarRouteChildren,
  poolBarRouteChildren,
  recordsRouteChildren,
  reservationsRouteChildren,
  restaurantRouteChildren,
  settingsRouteChildren,
  storeRouteChildren,
  statisticsRouteChildren,
  accountsRouteChildren,
} from "./routeChildren";
// project import
import MainLayout from "layout/MainLayout";
import CommonLayout from "layout/CommonLayout";
import { LinearLoadable } from "components/Loadables";
import AuthGuard from "utils/route-guard/AuthGuard";

// pages routing
const MaintenanceError = LinearLoadable(
  lazy(() => import("pages/maintenance/404"))
);
const MaintenanceError500 = LinearLoadable(
  lazy(() => import("pages/maintenance/500"))
);
const MaintenanceUnderConstruction = LinearLoadable(
  lazy(() => import("pages/maintenance/under-construction"))
);
const MaintenanceComingSoon = LinearLoadable(
  lazy(() => import("pages/maintenance/coming-soon"))
);

// render - sample page
const Modules = LinearLoadable(lazy(() => import("pages/Modules")));

// ==============================|| MAIN ROUTING ||============================== //

const ModuleRoutes = {
  path: "/",
  children: [
    {
      path: "/",
      element: (
        <AuthGuard>
          <MainLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "dashboard",
          element: <Modules />,
        },
        {
          path: "reservations",
          element: <Modules />,
          children: reservationsRouteChildren,
        },
        {
          path: "frontdesk",
          element: <Modules />,
          children: frondeskRouteChildren,
        },
        {
          path: "house-keeping",
          element: <Modules />,
          children: houseKeepingRouteChildren,
        },
        {
          path: "main-bar",
          element: <Modules />,
          children: mainBarRouteChildren,
        },
        {
          path: "pool-bar",
          element: <Modules />,
          children: poolBarRouteChildren,
        },
        {
          path: "restaurant",
          element: <Modules />,
          children: restaurantRouteChildren,
        },
        {
          path: "store",
          element: <Modules />,
          children: storeRouteChildren,
        },
        {
          path: "records",
          element: <Modules />,
          children: recordsRouteChildren,
        },
        {
          path: "settings",
          element: <Modules />,
          children: settingsRouteChildren,
        },
        {
          path: "backtrack",
          element: <Modules />,
          children: backtrackRouteChildren,
        },
        {
          path: "accounts",
          element: <Modules />,
          children: accountsRouteChildren,
        },
        {
          path: "statistics",
          element: <Modules />,
          children: statisticsRouteChildren,
        },
        // {
        //   path: 'kitchen',
        //   element: <Modules />,
        //   children: kitchenRouteChildren
        // },
      ],
    },
    {
      path: "/maintenance",
      element: <CommonLayout />,
      children: [
        {
          path: "404",
          element: <MaintenanceError />,
        },
        {
          path: "500",
          element: <MaintenanceError500 />,
        },
        {
          path: "under-construction",
          element: <MaintenanceUnderConstruction />,
        },
        {
          path: "coming-soon",
          element: <MaintenanceComingSoon />,
        },
      ],
    },
  ],
};

export default ModuleRoutes;
